/**
 * HTML string helpers.
 *
 * Extracted from main.ts as part of OMON-031 Phase 2. Uses the DOM
 * `textContent` → `innerHTML` round-trip so behaviour matches exactly
 * what the browser will render.
 */

export function escapeHtml(text: string): string {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}
